import * as React from 'react';
import { connect } from 'react-redux';

import CcmCampaignFormCreatorfull from '../components/form/components/creatorfull/CcmCampaignFormCreatorfull';
import { CcmCampaignFormCreatorless } from '../components/form/components/creatorless';

import { fetchCampaignBrief } from 'modules/campaigns/reducers/campaignBrief';

import './ccm-campaign-edit.scss';

import type { Campaign, PromiseAction } from 'types';

type OwnProps = {
  campaignId: number,
  organizationId: number,
  brandProfileId: number,
  onCloseModal: () => PromiseAction
};

type StateProps = {
  campaign: Campaign
};

type DispatchProps = {
  dispatchFetchCampaignBrief: (campaignId: number, showLoader?: boolean) => Promise<void>
};

type Props = OwnProps & StateProps & DispatchProps;

const CcmCampaignEdit: React.FC<Props> = ({
  campaignId,
  campaign,
  organizationId,
  brandProfileId,
  onCloseModal,
  dispatchFetchCampaignBrief
}): JSX.Element => {
  React.useEffect(() => {
    dispatchFetchCampaignBrief(campaignId);
  }, [campaignId]);

  return (
    <div className="ccm-campaign-edit">
      {campaign.campaignType === 'ccm_creatorless' ? (
        <CcmCampaignFormCreatorless
          campaign={campaign}
          pageHeading={<div />}
          organizationId={organizationId}
          brandProfileId={brandProfileId}
          onCloseModal={onCloseModal}
        />
      ) : (
        <CcmCampaignFormCreatorfull
          campaign={campaign}
          pageHeading={null}
          organizationId={organizationId}
          brandProfileId={brandProfileId}
          onCloseModal={onCloseModal}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ campaignBrief }): StateProps => ({
  campaign: campaignBrief.brief
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchFetchCampaignBrief: (campaignId: number, showLoader: boolean = false) => (
    dispatch(fetchCampaignBrief(campaignId, showLoader, false))
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(CcmCampaignEdit);
